<template>
  <div>
    <SpCardContent v-if="accountInfo.user_info">
      <div class="account-top">
        <div class="account-left">
          <div class="account-img">
            <img
              :src="accountInfo.user_info.avatar || ''"
              alt=""
            >
          </div>
          <div class="account-info">
            <div class="name">
              {{ accountInfo.user_info.user_name }}
            </div>
            <div class="role">
              {{ accountInfo.user_info.role_name }}
            </div>
            <div class="phone">
              {{ accountInfo.user_info.mobile }}
            </div>
          </div>
        </div>
        <div class="account-right">
          <div class="version">
            当前版本：<span>{{ accountInfo.resource_info.source_str }}</span>
          </div>
          <div class="time">
            到期时间：<span>{{ accountInfo.resource_info.expired_str }}</span>
          </div>
        </div>
      </div>
    </SpCardContent>

    <SpCardContent v-if="accountInfo.workwechat_info">
      <div class="company-top">
        <div>
          <div class="name">
            {{ accountInfo.workwechat_info.corp_name }}
          </div>
          <div>
            <img
              v-if="accountInfo.workwechat_info.corp_type === 'verified'"
              src="@/assets/img/certified.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/unauthorized.png"
              alt=""
            >
          </div>
        </div>
        <div>
          <a
            href="https://work.weixin.qq.com/wework_admin/frame#profile"
            target="_blank"
            style="font-size: 12px"
          >修改企业信息</a>
          <i
            class="refresh el-icon-refresh"
            @click="refreshAccountInfo"
          />
        </div>
      </div>
      <el-divider />
      <ul class="company">
        <li>
          <div class="title">
            企业全称
          </div>
          <div class="content">
            {{ accountInfo.workwechat_info.corp_full_name }}
          </div>
        </li>
        <li>
          <div class="title">
            企业地址
          </div>
          <div class="content">
            {{ accountInfo.workwechat_info.location }}
          </div>
        </li>
        <li>
          <div class="title">
            行业类型
          </div>
          <div class="content">
            {{ accountInfo.workwechat_info.corp_industry }} /
            {{ accountInfo.workwechat_info.corp_sub_industry }}
          </div>
        </li>
        <li>
          <div class="title">
            人员规模
          </div>
          <div class="content">
            {{ accountInfo.workwechat_info.corp_scale || '未设置' }}
          </div>
        </li>
        <li>
          <div class="title">
            企业 ID
            <el-tooltip
              effect="dark"
              content="可在企业微信-我的企业中查看"
              placement="top"
            >
              <i class="el-icon-info tooltip" />
            </el-tooltip>
          </div>
          <div class="content">
            {{ accountInfo.workwechat_info.corpid }}
          </div>
        </li>
      </ul>
    </SpCardContent>

    <SpCardContent v-if="companyInfo">
      <div class="compony-shop">
        <div class="title">
          <div>云店商城</div>
          <i
            class="refresh el-icon-refresh"
            @click="refreshCompanyInfo"
          />
        </div>
        <div class="shop">
          <div class="shop-img">
            <img
              :src="companyInfo.logo"
              alt=""
            >
          </div>
          <div>
            <div class="name">
              商城名称：{{ companyInfo.brand_name }}
            </div>
            <div class="company-id">
              COMPANYID: {{ companyInfo.company_id }}
            </div>
          </div>
        </div>
      </div>
    </SpCardContent>
  </div>
</template>

<script>
export default {
  data () {
    return {
      accountInfo: {},
      companyInfo: {},
      accountParams: {
        refresh: 0
      },
      companyParams: {
        refresh: 0
      }
    }
  },
  mounted () {
    this.getAccountInfo()
    this.getCompanyInfo()
  },
  methods: {
    async getAccountInfo (type) {
      const data = await this.$api.setting.getAccountInfo(this.accountParams)
      if (data) {
        this.accountInfo = data
        this.accountParams.refresh = 0
        if (type === 'refresh') {
          this.$message({
            message: '刷新成功',
            type: 'success'
          })
        }
      }
    },
    async getCompanyInfo (type) {
      const data = await this.$api.setting.getCompanyInfo(this.companyParams)
      if (data) {
        this.companyInfo = data
        this.companyParams.refresh = 0
        if (type === 'refresh') {
          this.$message({
            message: '刷新成功',
            type: 'success'
          })
        }
      }
    },
    refreshAccountInfo () {
      this.accountParams.refresh = 1
      this.getAccountInfo('refresh')
    },
    refreshCompanyInfo () {
      this.companyParams.refresh = 1
      this.getCompanyInfo('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
.account-top {
  display: flex;
  justify-content: space-between;

  .account-left {
    display: flex;
    align-items: center;
    .account-img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .account-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .name {
        font-size: 16px;
        color: #303133;
      }
      .role {
        font-size: 14px;
        color: #606266;
      }
      .phone {
        font-size: 14px;
        color: #606266;
      }
    }
  }
  .account-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 24px;
    .version {
      span {
        color: rgba(9, 187, 7, 0.65);
      }
    }
  }
}

.company-top {
  display: flex;
  justify-content: space-between;
  .name {
    font-size: 16px;
    color: rgb(48, 49, 51);
  }
}
.company {
  li {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 40px;
    .title {
      color: #909399;
      width: 120px;
      text-align: right;
      margin-right: 50px;
    }
    .content {
      color: #606266;
    }
  }
}

.compony-shop {
  .title {
    font-size: 16px;
    color: rgb(48, 49, 51);
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shop {
    display: flex;
    align-items: center;
    line-height: 34px;
    .shop-img {
      width: 80px;
      height: 80px;
      margin-right: 40px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
  }
}
.refresh {
  margin-left: 10px;
  font-size: 16px;
  cursor: pointer;
}
</style>
